import type { NodeId, SurveyNode } from '../dto/survey/survey-schema.types';

/**
 * Every node of the schema by id, the inner nodes of each repeat-block
 * included. Repeat-blocks cannot nest (`REPEAT_NESTED`), so one level would
 * be enough — this walks recursively anyway rather than assuming that
 * invariant a second time outside the validator.
 */
export function indexAllNodesById(nodes: readonly SurveyNode[]): Map<NodeId, SurveyNode> {
  const byId = new Map<NodeId, SurveyNode>();
  const walk = (level: readonly SurveyNode[]): void => {
    for (const node of level) {
      byId.set(node.id, node);
      if (node.type === 'repeat-block') {
        walk(node.innerNodes);
      }
    }
  };
  walk(nodes);
  return byId;
}
